import React from 'react';
import { AlertCircle, CheckCircle2 } from 'lucide-react';

function Message({ message, type }) {
  if (!message) return null;
  const isSuccess = type === 'success';
  
  // Para mensagens de erro longas com quebras de linha, usar whitespace-pre-line
  const hasLineBreaks = message.includes('\n');
  
  return (
    <div className={`mt-2 flex ${hasLineBreaks ? 'items-start' : 'items-center'} ${isSuccess ? 'text-green-600' : 'text-red-600'}`}>
      {isSuccess ? (
        <CheckCircle2 className="w-6 h-6 mr-2 min-w-[24px] min-h-[24px] mt-1" />
      ) : (
        <AlertCircle className="w-6 h-6 mr-2 min-w-[24px] min-h-[24px] mt-1" />
      )}
      <span 
        className={`text-base font-medium ${hasLineBreaks ? 'whitespace-pre-line' : ''}`}
      >
        {message}
      </span>
    </div>
  );
}

export default Message;
